module.exports = __webpack_public_path__ + "img/collection-diamondJewelry@2x.b9809a0.jpg";